import { ToolbarProps } from "elements/base/provider";
import { TaskElement } from "../schema";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function TaskToolbar({ ids, elements, context }: ToolbarProps<TaskElement>) {
  return <></>;
}
